import contentRequest from '~/src/api/requests/contentRequest';
import { isAxiosError } from '~/src/helpers/whoseError';
import { captureException } from '@sentry/node';

interface IParams {
    domain?: string,
    city_id?: number,
    filter?: Array<string>,
    active?: boolean,
}

interface ICity {
    [key:string]: string | number,
}

interface IResp {
    ok: boolean,
    data: ICity | null,
    error: string,
}

/**
 * GET-запрос свойств города
 *
 * https://api-content.dom.ru/v1/geography/get-city-info?filter=city_id,id,domain&city_id=1&onlyActive=true
 * @param domain - доменное имя города, необязательно
 * @param city_id - айди города в биллинге, необходимо указать в запросе или city_id или domain
 * @param filter - возвращаемые поля, если не указано то вернет все
 * @param active - искать в только активных или во всех городах
 * @returns {Promise<any|undefined>}
 */
export const getCityInfo = async({ domain, city_id, filter, active = false  }: IParams): Promise<IResp> => {
    const params = {
        domain,
        city_id,
        filter: filter?.join(','),
        onlyActive: active,
    };

    try {
        const resp = await contentRequest.getWithCache('/v1/geography/get-city-info', { params });

        return {
            ok: true,
            data: resp.data,
            error: '',
        };
    } catch (err) {
        if (isAxiosError(err)) {
            return {
                ok: false,
                data: null,
                error: err.response?.statusText || '',
            };
        }

        captureException(err);

        return {
            ok: false,
            data: null,
            error: 'Внутренняя ошибка сервера',
        };
    }
};
